//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Importer.js";
import "../no/ugmath.js";
let d=[[[0,"CreateNamedGroup",1,0],[0,"DestinationCoordinateSystem",1,"NXMatrix",0],[0,"DestinationCoordinateSystemSpecification",1,0],[0,"DestinationPoint",1,0],[0,"ImportCamObjects",1,0],[0,"ImportViews",1,0],[0,"LayerOption",1,0],[0,"Scale",1,0]],[[["specified_coordinate_system"],"SetSpecifiedCoordinateSystem",{},1,0],[["specified_coordinate_system","delete_specified_coordinate_system"],"SetSpecifiedCoordinateSystemWithDeleteOption",{},2,0]],[]];
SPLM.PartImporter = class extends SPLM.Importer{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartImporter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PartImporter.LayerOptionType = Object.freeze({
    "Work" : "Work", "Original" : "Original"});

SPLM.PartImporter.DestinationCoordinateSystemSpecificationType = Object.freeze({
    "Work" : "Work", "Specified" : "Specified"});

export default SPLM;